import React from "react";
import CustomChart from "../../components/customChart/customChart";
import { AnswerContext } from "../../store/answerStore";
import { HelperContext } from "../../store/helperStore";
import ReactionSummary from "./reactionSummary";

// int total = xCorrectCount.get() + nonxCorrectCount.get();
// if (xComCount.get() + nonxComCount.get() > 2) {
//     if (nonxQuickCount.get() > 8) {
//         int less = nonxQuickCount.get() - 8;
//         total = total - less;
//     }
// }
// total = total - xInCorrectCount.get() - nonxInCorrectCount.get();
// if (total < 0) {
//     total = 0;
// }

export default function TestSumCPT() {
  const { answerC, dispatchAnswer } = AnswerContext();
  const { helperC } = HelperContext();
  // let avgTime
  let totalScore = 0;
  let correct = 0;
  let inCorrect = 0;
  let omission = 0;
  let commission = 0;
  let quickTap = 0;
  let totalTime = 0;

  answerC.answers.forEach((answer) => {
   /* Not required
   if (answer.answer === "Y" || answer.answer === "Q") {
      correct = correct + 1;
    } else inCorrect = inCorrect + 1;

	if (answer.answer_flag === "Quick Tap") {
      quickTap = quickTap + 1;
    }

    if (answer.answer_flag === "Omission") {
      omission = omission + 1;
    }

    if (answer.answer_flag === "Commission") {
      commission = commission + 1;
    }
	*/
	
	if (answer.answer_flag === "") {
      correct = correct + 1;
    } else if (answer.answer_flag === "Quick Tap") {
      quickTap = quickTap + 1;
      correct = correct + 1;
    } else if (answer.answer_flag === "Omission") {
      inCorrect = inCorrect + 1;
      omission = omission + 1;
    } else if (answer.answer_flag === "Commission") {
      inCorrect = inCorrect + 1;
      commission = commission + 1;
    }
	
    totalScore = totalScore + answer.que_score;
    totalTime = totalTime + answer.que_time;
  });

  if (commission > 2 && quickTap > 8) {
    const tapToLess = quickTap - 8;
    totalScore = totalScore - tapToLess;
  }

  totalTime = totalTime / answerC.answers.length;

  return (
    <div className="sum-dnb">
      <ReactionSummary
        totalScore={Math.sign(totalScore) === -1 ? 0 : Math.floor(totalScore)}
        averageTimeSpend={totalTime}
        quickTap1={quickTap}
        omi1={omission}
        com1={commission}
        correct1={correct}
        incorrect1={inCorrect}
        totalTap={helperC.totalTap}
      />
    </div>
  );
}
